// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c65a4b16","239":"a0db7a03","455":"37f81474"}[chunkId] + ".chunk.js";
};